import { post } from "../utils/request";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      normId: "",
      normItems: "",
      rateScoreList: [],
    };
  },
  name: "RateManage",
  methods: {
    selectMenu(index) {
      this.normId = index;
    },
    handleAdd() {
      if (this.normId == "") {
        ElMessage.warning("请先在左侧选择要配置的指标", {
          duration: 3 * 1000,
        });
        return;
      }
      this.rateScoreList.push({ isOk: true, departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId, normId: this.normId });
    },
    /**
     * @description 删除评等配置
     * @function POST /normRate/delete
     * 
     * @param {int} id norm_rate表中ID
     * 
     */
    handleDelete(index, row) {
      post('/normRate/delete', JSON.stringify(row.id)).then(res => {
        if (res.code == 200) {
          this.rateScoreList.splice(index, 1);
        }
      });
    },
    // 只查询共性指标
    searchNorm() {
      let data = {
        normType: 1,
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        type: 1,
      }
      post('/norm/search/batch', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.normItems = JSON.parse(res.data.normItems)[0].children;
          console.log(JSON.parse(res.data.normItems))
        }
      });
    },

    rowDoubleClick(row, event, column) {
      row.isOk = !row.isOk;
    },
    /**
     * @description 查找指标对应的考评等次
     * @function POST /normRate/search
     * 
     * @param normId int 指标ID
     * @param departmentId int 局ID
     * 
     * @returns rateScoreList[]
     * @returns 集合中每一项都要表中所有字段
     */
    searchNormRate() {
      let data = {
        departmentId: JSON.parse(sessionStorage.getItem('departmentInfo')).departmentId,
        normId: this.normId
      }
      post('/normRate/search', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.rateScoreList = JSON.parse(res.data.rateScoreList);
        }
        if (res.code == 204) {
          this.rateScoreList = [];
        }
      });
    },
    /**
     * @description 保存考评等次数据，遍历参数时，如果id不存在则新增，如果id存在则修改
     * @function POST /normRate/save
     * 
     * @param {Object[]} rateScoreList
     * @param {int} rateScoreList[].id 序号
     * @param {int} rateScoreList[].normId 指标ID
     * @param {String} rateScoreList[].rateName 等次名称
     * @param {int} rateScoreList[].rateScore 等次分数
     * @param {int} rateScoreList[].departmentId 局ID
     * @param {int} rateScoreList[].upperLimit 上限比例
     */
    handleSave() {
      post('/normRate/save', JSON.stringify(this.rateScoreList)).then(res => {
      });
    }
  },
  created() {
    this.searchNorm();
  },
  watch: {
    normId() {
      this.searchNormRate();
    }
  }
};